import React, { useRef, useEffect } from 'react';

/**
 * 淡墨粒子背景 — Canvas 实现的缓慢飘动水墨粒子效果
 * 营造东方美学氛围，不干扰内容阅读
 */
export default function InkParticles() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animationId;
    let particles = [];

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    // 生成墨粒子：深灰/暖黑，低透明度，随机大小
    const spawn = () => {
      const x = Math.random() * canvas.width;
      const y = canvas.height + 20;
      const size = Math.random() * 3 + 1;
      const opacity = Math.random() * 0.06 + 0.02;
      const speedY = Math.random() * 0.3 + 0.1;
      const sway = Math.random() * 0.3 - 0.15;
      const hue = Math.random() * 30 + 20; // 暖色调 20-50
      particles.push({ x, y, size, opacity, speedY, sway, hue, phase: Math.random() * Math.PI * 2 });
    };

    // 初始粒子
    for (let i = 0; i < 40; i++) {
      const p = {
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 3 + 1,
        opacity: Math.random() * 0.06 + 0.02,
        speedY: Math.random() * 0.3 + 0.1,
        sway: Math.random() * 0.3 - 0.15,
        hue: Math.random() * 30 + 20,
        phase: Math.random() * Math.PI * 2,
      };
      particles.push(p);
    }

    let frameCount = 0;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      frameCount++;

      // 缓慢生成新粒子
      if (frameCount % 8 === 0 && particles.length < 60) spawn();

      particles = particles.filter((p) => {
        p.y -= p.speedY;
        p.x += Math.sin(frameCount * 0.01 + p.phase) * p.sway;

        // 画粒子
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = `hsla(${p.hue}, 15%, 20%, ${p.opacity})`;
        ctx.fill();

        // 偶尔画一个更淡的光晕
        if (Math.random() < 0.02) {
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.size * 2.5, 0, Math.PI * 2);
          ctx.fillStyle = `hsla(${p.hue}, 15%, 20%, ${p.opacity * 0.3})`;
          ctx.fill();
        }

        return p.y > -20;
      });

      animationId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none z-0"
      aria-hidden="true"
    />
  );
}
